import smartsoftService from '../services/smartsoft.service'

const handlers = {
  smartsoft: {
    session: {
      set: 'smartsoft_session_set'
    }
  }
}

const initVuexState = function(state) {
  state.smartsoft = {
    session: null
  };
}

const initGetters = function(getters) {
  getters.smartsoft = (state => state.smartsoft);
}

const initActions = function(actions) {
  actions[handlers.smartsoft.session.set] = ({ commit }, session) => commit(handlers.smartsoft.session.set, session);
}

const initMutations = function(mutations) {
  mutations[handlers.smartsoft.session.set] = (state, session) => state.smartsoft.session = session;
}

const initAppState = function(appState, store) {
  appState.smartsoft = {
    session: {
      get: () => store.getters.smartsoft.session,
      open: async (gameId, language, isMobile) => {
        let session = await smartsoftService.openSession(gameId, language, isMobile);
        store.dispatch(handlers.smartsoft.session.set, session);
      },
      openDemo: async (gameId, language, isMobile) => {
        let session = await smartsoftService.openDemoSession(gameId, language, isMobile);
        store.dispatch(handlers.smartsoft.session.set, session);
      },
      close: async () => {
        if (store.getters.smartsoft.session) {
          await smartsoftService.closeSession();
        }
        store.dispatch(handlers.smartsoft.session.set, null);
      }
    }
  }
}

export default {
  initVuex(vuexState, getters, actions, mutations) {
    initVuexState(vuexState);
    initGetters(getters);
    initActions(actions);
    initMutations(mutations);
  },
  initAppState(appState, store) {
    initAppState(appState, store);
  }
}



// WEBPACK FOOTER //
// ./_common/data/smartsoft.js